import { createSelector } from "@reduxjs/toolkit"

// export const selectedUpholsterySelector = createSelector<
//   RootState,
//   UpholsteryState["upholsteries"],
//   UpholsteryState["selectedUpholsteryCode"],
//   UpholsteryState["upholsteries"][number] | undefined
// >(
//   (state) => state.upholstery.upholsteries,
//   (state) => state.upholstery.selectedUpholsteryCode,
//   (upholsteries, selectedUpholsteryCode) =>
//     upholsteries.find(
//       (upholstery) => upholstery.details.code === selectedUpholsteryCode
//     )
// )
export const selectedUpholsterySelector = createSelector(
  (state) => state.upholstery.upholsteries,
  (state) => state.upholstery.selectedUpholsteryCode,
  (upholsteries, selectedUpholsteryCode) =>
    upholsteries.find(
      (upholstery) => upholstery.details.code === selectedUpholsteryCode
    )
)
